"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgSmiley2Filled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M16 2a14 14 0 1014 14A14 14 0 0016 2zm5.35 20.76A9.06 9.06 0 0016 21a8.88 8.88 0 00-5.35 1.76l-1.3-1.52a11 11 0 0113.3 0zM10 13a2 2 0 112 2 2 2 0 01-2-2zm8 0a2 2 0 112 2 2 2 0 01-2-2z" })));
}
exports.default = SvgSmiley2Filled;
//# sourceMappingURL=Smiley2Filled.js.map